import { slideDown, slideUp } from '../modules/domSlider';
import { setListenersFromSelector } from './listeners';
import { querySelectorId } from './querySelectors';

const INPUT_CLASS = 'w-switch__input';
const INPUT_INIT_CLASS = 'wsi-init';
const DESTINY_CHECKED_ATTR = 'data-destiny-checked';
const DESTINY_UNCHECKED_ATTR = 'data-destiny-unchecked';
export const ACTIVE_CLASS = 'w-switch__content-active';
export const INACTIVE_CLASS = 'w-switch__content-inactive';

let changeStatus = function(input) {
  let checked = querySelectorId(input.getAttribute(DESTINY_CHECKED_ATTR));
  let unchecked = querySelectorId(input.getAttribute(DESTINY_UNCHECKED_ATTR));

  if (unchecked) {
    if (input.checked) {
      slideUp({
        element: unchecked
      });
      unchecked.classList.remove(ACTIVE_CLASS);
      unchecked.classList.add(INACTIVE_CLASS);
    }
    else {
      slideDown({
        element: unchecked
      });
      unchecked.classList.add(ACTIVE_CLASS);
      unchecked.classList.remove(INACTIVE_CLASS);
    }
  }

  if (checked) {
    if (input.checked) {
      slideDown({
        element: checked
      });
      checked.classList.add(ACTIVE_CLASS);
      checked.classList.remove(INACTIVE_CLASS);
    }
    else {
      slideUp({
        element: checked
      });
      checked.classList.remove(ACTIVE_CLASS);
      checked.classList.add(INACTIVE_CLASS);
    }
  }
};

let inputChange = function(event) {
  changeStatus(this);
};

export function setSwitchers() {
  let items = setListenersFromSelector(
    `.${INPUT_CLASS}`,
    INPUT_INIT_CLASS,
    inputChange,
    true,
    'change'
  );

  window.addEventListener('pageshow', function() {
    items.forEach((item) => {
      changeStatus(item);
    });
  });
}
